module.exports = __webpack_public_path__ + "img/Seyond.ce29dbbe.jpg";